var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { fixedForwardRef } from './fixedForwardRef';
import classNames from 'classnames';
/**
 * Internal component
 * @ignore
 */
function InlineBaseButtonWithForwardRef(props, ref) {
    var _a = props.as, Comp = _a === void 0 ? 'button' : _a, buttonType = props.buttonType, className = props.className, leftIcon = props.leftIcon, rightIcon = props.rightIcon, _b = props.size, size = _b === void 0 ? 'md' : _b, _c = props.iconOnly, iconOnly = _c === void 0 ? false : _c, children = props.children, rest = __rest(props, ["as", "buttonType", "className", "leftIcon", "rightIcon", "size", "iconOnly", "children"]);
    return (React.createElement(Comp, __assign({ className: classNames('ffe-inline-button', className, "ffe-inline-button--".concat(size), "ffe-inline-button--".concat(buttonType), { 'ffe-inline-button--icon-only': iconOnly }) }, rest, { ref: ref }),
        leftIcon &&
            React.cloneElement(leftIcon, {
                className: 'ffe-inline-button__icon ffe-inline-button__icon--left',
                size: 'md',
            }),
        React.createElement("span", { className: "ffe-inline-button__label" }, children),
        rightIcon &&
            React.cloneElement(rightIcon, {
                className: 'ffe-inline-button__icon ffe-inline-button__icon--right',
                size: 'md',
            })));
}
export var InlineBaseButton = fixedForwardRef(InlineBaseButtonWithForwardRef);
